import { values } from './enums'

const _enum = {
  Local: 1,
  Foreign: 2
}

export const bankNationality = {
  enumName: 'BankNationality',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/BankNationality.js